const initInput = (input, defaultCountryCode, intlTelInput) => {
    const defaultCountry = getDefaultCountryCode();
    if (!defaultCountry) {
        console.error('Default country code could not be determined.');
        return;
    }
    try {
        intlTelInput(input, {
            utilsScript: '/dist/chunks/intl-tel-input/utils.js',
            initialCountry: defaultCountry,
        });
    }
    catch (error) {
        console.error('Error initializing intl-tel-input:', error);
    }
};
const getDefaultCountryCode = () => {
    const lang = document.documentElement.lang;
    if (!lang) {
        console.error('HTML lang attribute not found.');
        return null;
    }
    const langToCountryCodeMap = {
        de: 'de',
        en: 'uk',
        fr: 'fr',
        es: 'es',
        ja: 'jp',
        ch: 'ch',
        it: 'it',
    };
    return langToCountryCodeMap[lang] || null;
};
export const initInternationalPhoneInputs = () => {
    const inputs = document.querySelectorAll('.inputTel');
    if (inputs.length === 0) {
        return;
    }
    const defaultCountryCode = getDefaultCountryCode();
    if (!defaultCountryCode) {
        console.error('Default country code could not be determined');
        return;
    }
    import('intl-tel-input').then(({ default: intlTelInput }) => inputs.forEach((input) => initInput(input, defaultCountryCode, intlTelInput)));
};
